import styled, { css } from 'styled-components';
import { mediaBreakpointUp } from '@whitelabel/helpers/style/grid';
import Button from '@whitelabel/component-library/src/components/Button';
import { color, themeColor } from '@whitelabel/helpers/style/colors';
import { fontStyle, fontWeight } from '@whitelabel/helpers/style/type';

export const StyledNavIcon = styled.svg`
  display: block;
  margin-inline-end: 0.5rem;
`;

export const StyledNavButton = styled(Button)<{ $spaceBetween?: boolean }>`
  padding: 0;
  display: flex;
  align-items: center;
  white-space: nowrap;
  color: ${themeColor('subheading')};

  // Force "Button" component not to set direction so that margin-inline on icons work as intended
  direction: unset;
  flex-direction: unset;

  justify-content: left;

  ${({ $spaceBetween }) =>
    $spaceBetween &&
    css`
      justify-content: space-between;
      width: 100%;
    `}

  margin-bottom: 1rem;

  ${mediaBreakpointUp('lg')`
      margin-bottom: 0;
    `}
  &:hover {
    svg {
      path {
        fill: ${themeColor('heading')};
      }
    }
  }

  .locale-button-nav-item {
    width: 100%;
    display: flex;
    align-items: center;
  }

  .locale-button-text {
    font-size: 1rem;
    text-transform: none;
    font-weight: normal;
    margin-bottom: 0;
  }

  .language-nav-text {
    ${fontStyle('button')};
    font-weight: ${fontWeight('black')};
    margin-bottom: 0;
  }

  .nav-item-extra-label {
    margin-inline-start: 0.25rem;
    padding: 0.25rem;
    border-radius: 3px;
    border: 1px solid #b84604;
    color: #b84604;
  }
`;

const borderWidth = '0.05rem';

// margin-inline-start: -0.33rem is to center the icon for rounding
export const StyledNavIconWrapper = styled.div<{ $withRounding?: boolean }>`
  &&&& {
    margin-inline-end: 0.25rem;
  }
  width: 1rem;
  height: 1rem;
  overflow: hidden;

  html[dir='rtl'] & {
    direction: rtl;
  }

  svg {
    path {
      fill: ${themeColor('subheading')};
    }
  }

  ${({ $withRounding }) =>
    $withRounding &&
    css`
      border: ${borderWidth} solid ${color('oliveDrab')};
      border-radius: 50%;
      &&& > svg {
        margin-inline-start: calc(-0.33rem - ${borderWidth});
        margin-top: calc(-0.05rem - ${borderWidth});
      }
    `}

  > .flag-image {
    max-width: none;
    height: 1.2rem;
    margin-inline-start: -0.33rem;
    margin-top: -0.3rem;
  }
`;
